import moment from 'moment';

import { DUMMY_SLUG } from '../constants/cms';


const sortArticles = (a, b) => {
  const momentA = moment(a.date);
  const momentB = moment(b.date);

  if (momentA.isBefore(momentB)) {
    return 1;
  }
  if (momentB.isBefore(momentA)) {
    return -1;
  }
  return 0;
};

const sortEvents = (a, b) => {
  const momentA = moment(a.date);
  const momentB = moment(b.date);

  if (momentA.isBefore(momentB)) {
    return -1;
  }
  if (momentB.isBefore(momentA)) {
    return 1;
  }
  return 0;
};


export const getUpcomingEvents = (events, limit) => {
  const yesterday = moment().subtract(1, 'days');
  return events.filter((e) => e.node.slug !== DUMMY_SLUG)
    .filter(({ node: { date } }) => moment(date) > yesterday)
    .map((e) => e.node)
    .sort(sortEvents)
    .slice(0, limit); // if `limit` is `undefined`, all items will be included
};

export const getSortedArticles = (articles) => articles.filter((a) => a.node.slug !== DUMMY_SLUG)
  .map((a) => a.node)
  .sort(sortArticles);


// Handle cases where an expected date string is an invalid value that would be treated as moment(), e.g. from URL search params.
// https://github.com/moment/moment/issues/3180
export const isValidDateString = (value) => typeof value === 'string'
      && value.length
      && moment(value, moment.ISO_8601, true).isValid();
